import React, { useEffect, useState } from "react";
import { Route, withRouter, useHistory } from "react-router-dom";
import "./Invoices.css";
import { motion } from "framer-motion";
import {
  pageTransitions,
  transitionDuration,
} from "../../../../../Util/PageTransitions";
import "./Invoices.css";
import DatePicker from "react-datepicker";
import sendIcon from "../../../../../assets/send-white.png";
import trashIcon from "../../../../../assets/trash-white.png";
import plusIcon from "../../../../../assets/plus-icon.svg";
import refundIcn from "../../../../../assets/refund.svg";
import minusPriIcon from "../../../../../assets/minus-pri.png";
import NumberFormat from 'react-number-format';
import { config } from '../../../../../config';
import axiosApi from '../../../../../core/interceptor/interceptor';
import WarningDialogue from '../../../../../Util/WarningDialogue';
import { faExclamationTriangle, faEye, faReply } from '@fortawesome/free-solid-svg-icons';
import { PAYMENT_STATUS, LEAGUE_STATUS, getStripeAmount } from '../../../../../Util/helper';
import CustomSelect from '../../../../../Util/CustomSelect/CustomSelect';
import moment from 'moment';
import RedundPopup from "../RedundPopup";
function Invoices(props) {
  const invoicePerItem = {
    date: null,
    item: '',
    qty: 0,
    unit_cost: 0,
    tax: 0,
    total: 0,
  };
  const invoiceObj = {
    invoice_number: '',
    name: '',
    invoice_date: '',
    due_date: '',
    po_number: '',
    type: props.type,
    total: 0,
    event_invoice_details: [{ ...invoicePerItem }],
    lead_id: props.leadId || 0,
    event_id: props.eventId || 0,
    status: 'unpaid',
    saved_status: 'unpaid',
    payment_type: null
  };
  // const history = useHistory();
  const [invoiceList, setInvoiceList] = useState([{ ...invoiceObj }]);
  const [errors, setErrors] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const [refundPopup, setRefundPopup] = useState(false);
  const [refundInfo, setRefundInfo] = useState({
    id: 0,
    total: 0
  });
  useEffect(() => {
    props.childFunc.current = addInvoice;

    if (props.leadId) {
      getAllInvoiceForLeads(props.leadId);
    } else if (props.eventId) {
      getAllInvoiceForEvents(props.eventId);
    }
  }, [])

  useEffect(() => {
    handleValidation();
    console.log('calling from useEffect ==>> ', invoiceList);
  }, [invoiceList])

  // Add New invoice
  const addInvoice = () => {
    const temp = { ...invoiceObj, event_invoice_details: [{ ...invoicePerItem }] };
    setInvoiceList((prev) => ([...prev, temp]))
  }

  //Remove invoice item
  const removeInvoice = (index) => {

    let temp = [...invoiceList];
    if (temp[index]) {
      if (temp[index]['id']) {
        setOpenWarningPopup(true);
        setPopUpContent({
          header: 'Warning',
          description: 'Are you sure want to delete invoice ?',
          icon: faExclamationTriangle,
          action: () => {
            axiosApi.delete(`${config.apiUrl}/invoice/delete/${temp[index]['id']}`)
              .then((response) => {
                temp.splice(index, 1);
                setInvoiceList(temp)
                setOpenWarningPopup(false);
              })
              .catch((error) => {
                setOpenWarningPopup(false);
              });
          }
        });
      } else {
        temp.splice(index, 1);
        setInvoiceList(temp)
      }
    }
  }

  // Add new invoice item
  const addInvoiceItem = (index) => {
    let temp = [...invoiceList];
    if (temp[index]) {
      if (!['unpaid'].includes(temp[index].saved_status)) {
        return;
      }
      temp[index].event_invoice_details.push({ ...invoicePerItem });
      setInvoiceList(temp)
    }
  }

  // Remove invoice item
  const removeInvoiceItem = (index, childIndex) => {
    let temp = [...invoiceList];
    if (temp[index]) {
      if (!['unpaid'].includes(temp[index].saved_status)) {
        return;
      }
      if (temp[index]['id'] && temp[index]?.event_invoice_details[childIndex]?.id) {
        setOpenWarningPopup(true);
        setPopUpContent({
          header: 'Warning',
          description: 'Are you sure want to delete invoice item ?',
          icon: faExclamationTriangle,
          action: () => {
            if (!temp[index]['deleted']) {
              temp[index]['deleted'] = [];
            }
            temp[index]['deleted'].push(temp[index]?.event_invoice_details[childIndex]?.id);
            temp[index].event_invoice_details.splice(childIndex, 1);
            setInvoiceList(temp);
            setOpenWarningPopup(false);
            calculate(index);
          }
        });
      } else {
        temp[index].event_invoice_details.splice(childIndex, 1);
        setInvoiceList(temp);
        calculate(index);
      }
    }
  }

  const formChange = (e, index) => {
    let temp = [...invoiceList];
    if (temp[index]) {
      temp[index][e.target.name] = e.target.value;
    }
    setInvoiceList(temp);
  }

  const formChangeSub = (e, p, c) => {
    let temp = [...invoiceList];
    if (temp[p] && temp[p]['event_invoice_details'][c]) {
      temp[p]['event_invoice_details'][c][e.target.name] = e.target.value;
    }
    setInvoiceList(temp);
    calculate(p);
  }

  const submitInvoice = (index, sendEmail) => {
    const updateInvoice = (resp) => {
      const temp = [...invoiceList];
      temp[index] = {
        id: resp.id,
        invoice_number: resp.invoice_number,
        name: resp.name,
        invoice_date: new Date(resp.invoice_date),
        due_date: new Date(resp.due_date),
        po_number: resp.po_number,
        type: resp.type,
        total: resp.total,
        sent_to_user: resp.sent_to_user,
        sent_date: resp.sent_date,
        status: resp.status,
        saved_status: resp.status,
        payment_type: resp.payment_type,
        event_invoice_details: resp.event_invoice_details.map(x => {
          x.date = new Date(x.date);
          return x;
        }),
        lead_id: resp.lead_id,
        event_id: resp.event_id,
      };
      setInvoiceList(temp);
    }
    if (invoiceList[index]) {
      let temp = [...invoiceList];
      temp[index].submitted = true;
      setInvoiceList(temp);

      if (handleValidation(index)) {

        if (invoiceList[index].id) {
          axiosApi.put(`${config.apiUrl}/invoice/${invoiceList[index].id}`, invoiceList[index])
            .then((res) => {
              if (res?.data.data) {
                updateInvoice(res.data.data);
                //Send email
                if (sendEmail) {
                  setOpenWarningPopup(false);
                  axiosApi.post(`${config.apiUrl}/invoice/send-email`, {
                    id: invoiceList[index]['id'],
                    type: invoiceList[index]['type'],
                  }).then((res) => {
                  }).catch((e) => {
                  });
                }
              }
            })
        } else {
          axiosApi.post(`${config.apiUrl}/invoice/`, invoiceList[index])
            .then((res) => {
              if (res && res.data.data) {
                const resp = res.data.data;
                updateInvoice(resp);
              }
            })
        }

      }
    }
  }

  // Check validations
  const handleValidation = () => {
    let valid = true;
    let temp = [];
    if (invoiceList && invoiceList.length > 0) {
      invoiceList.forEach((val, i) => {
        if (!temp[i]) {
          temp[i] = [];
        }

        const keys = ['invoice_number', 'name', 'invoice_date', 'due_date', 'po_number', 'event_invoice_details'];
        keys.forEach((field) => {
          if (!val[field] || (field === 'event_invoice_details' && !val[field].length)) {
            temp[i][field] = true;
            valid = false;
          }
        });

        temp[i]['event_invoice_details'] = [];
        val.event_invoice_details.forEach((item, k) => {
          temp[i]['event_invoice_details'][k] = {};
          Object.keys(item).forEach(field => {
            if (!item[field] && field !== 'tax' && field !== 'date') {
              temp[i]['event_invoice_details'][k][field] = true;
              valid = false;
            }
          })
        })
      })
      console.log('---', temp)
      setErrors(temp);
    }
    return valid;
  }

  // Calculate total amount
  const calculate = (index) => {
    if (invoiceList && invoiceList.length) {
      const temp = [...invoiceList];

      if (temp[index] && temp[index].event_invoice_details.length) {
        let total = 0;
        temp[index].event_invoice_details.forEach((item) => {
          let subTotal = 0;
          if (item.qty > 0 && item.unit_cost > 0) {
            subTotal = (item.qty * item.unit_cost).toFixed(2);

            if (item.tax) {
              subTotal = +subTotal + +item.tax;
            }
          }

          item.total = subTotal;
          total += + subTotal;
        })
        temp[index]['total'] = getStripeAmount(total.toFixed(2));
        temp[index]['stripe_fee'] = (+temp[index]['total'] - +total.toFixed(2)).toFixed(2);
      }

      setInvoiceList(temp);
    }
  }

  const getAllInvoiceForLeads = (id) => {
    axiosApi.get(`${config.apiUrl}/invoice/lead/${id}`)
      .then((res) => {
        if (res && res?.data?.data) {
          const temp = res?.data?.data;

          temp.forEach((val) => {
            val.due_date = new Date(val.due_date);
            val.invoice_date = new Date(val.invoice_date);
            val.event_invoice_details.forEach((item) => {
              item.date = new Date(item.date);
            })
            val.saved_status = val.status;
            val.payment_type = val.payment_type;

          })
          console.log('getAllInvoiceForLeads temp ==>> ', temp);
          setInvoiceList(temp);
        }
      })
  }

  const getAllInvoiceForEvents = (id) => {
    axiosApi.get(`${config.apiUrl}/invoice/event/${id}`)
      .then((res) => {
        if (res && res?.data?.data) {
          const temp = res?.data?.data;
          temp.forEach((val) => {
            val.due_date = new Date(val.due_date);
            val.invoice_date = new Date(val.invoice_date);
            val.event_invoice_details.forEach((item) => {
              item.date = new Date(item.date);
            })
            val.saved_status = val.status;
            val.payment_type = val.payment_type;
          })
          console.log('getAllInvoiceForEvents temp ==>> ', temp);
          setInvoiceList(temp);
        }
      })
  }

  const sendEmail = (index) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: 'Are you sure want to send invoice email to customer ?',
      icon: faExclamationTriangle,
      action: () => {
        submitInvoice(index, true);
      }
    });
  }

  const refundAmount = (row) => {
    setRefundPopup(true);
    setRefundInfo({
      id: row.id,
      total: +row.total
    });
  }

  const refund = (amount) => {
    setRefundPopup(false);
    refundInfo.total = amount;
    if (refundInfo.id && refundInfo.total) {
      axiosApi.post(`${config.apiUrl}/invoice/refund`, refundInfo)
        .then((res) => {
          setRefundInfo({});
        });
    }
  }

  return (
    <>
      <motion.div
        className="outer-wrapper cs-leads-page"
        initial={pageTransitions.initial}
        animate={pageTransitions.in}
        exit={pageTransitions.out}
        transition={{ duration: transitionDuration }}
      >
        <div className="leagues-wrapper">
          <div className="mul-events-body cs-new-events-body">
            <div className="invoices-tab-body">
              <div className="invoices-cards">
                {
                  invoiceList && invoiceList.length > 0 && invoiceList.map((val, k) => (
                    <div className="invoice-card open" key={k}>
                      <div className={`invoice-card-contents ${val.status === 'paid' ? 'paid-invoice' : val.status === 'status' ? 'refunded' : ''}`} >
                        <div className="header">
                          <div className={`in-card-header ${['paid', 'refunded'].includes(val.saved_status) ? 'addon' : ''}`}>
                            <div className="in-card-item">
                              <span>Invoice Number</span>
                              <input type="text" placeholder="" name="invoice_number" value={val.invoice_number} onChange={(e) => formChange(e, k)} className={`${errors[k] && val.submitted && errors[k]?.invoice_number ? 'errors' : ''}`} disabled={!['unpaid'].includes(val.saved_status)} />
                            </div>
                            <div className="in-card-item">
                              <span>Invoice Name</span>
                              <input type="text" placeholder="" name="name" value={val.name} onChange={(e) => formChange(e, k)} className={`${errors[k] && val.submitted && errors[k]?.name ? 'errors' : ''}`} disabled={!['unpaid'].includes(val.saved_status)} />
                            </div>
                            <div className="in-card-item">
                              <span>Invoice Date</span>
                              <DatePicker
                                placeholderText={""}
                                minDate={new Date()}
                                selected={val.invoice_date}
                                onChange={(e) => e && formChange({ target: { name: 'invoice_date', value: e } }, k)}
                                className={`${errors[k] && val.submitted && errors[k]?.invoice_date ? 'errors' : ''}`}
                                disabled={!['unpaid'].includes(val.saved_status)}
                              />
                            </div>
                            <div className="in-card-item">
                              <span>Due Date</span>
                              <DatePicker
                                placeholderText={""}
                                minDate={new Date()}
                                selected={val.due_date}
                                onChange={(e) => e && formChange({ target: { name: 'due_date', value: e } }, k)}
                                className={`${errors[k] && val.submitted && errors[k]?.due_date ? 'errors' : ''}`}
                                disabled={!['unpaid'].includes(val.saved_status)}
                              />
                            </div>
                            <div className="in-card-item">
                              <span>PO Number</span>
                              <input type="text" placeholder="" name="po_number" value={val.po_number} onChange={(e) => formChange(e, k)} className={`${errors[k] && val.submitted && errors[k]?.po_number ? 'errors' : ''}`} disabled={!['unpaid'].includes(val.saved_status)} />
                            </div>
                            <div className={`in-card-item ${val.payment_type === null ? '' : ['paid', 'refunded'].includes(val.saved_status) ? 'disabled-input' : ''}`}>
                              <span>Status</span>
                              <CustomSelect
                                data={[
                                  {
                                    title: 'Paid',
                                    value: 'paid'
                                  },
                                  {
                                    title: 'UnPaid',
                                    value: 'unpaid'
                                  },
                                  {
                                    title: 'Failed',
                                    value: 'failed'
                                  },
                                ]}
                                placeholder={val.status ? LEAGUE_STATUS[val.status] : 'Unpaid'}
                                onSelect={(e) => e && formChange({ target: { name: 'status', value: e.value } }, k)}
                                selector="title"
                                disabled={val.payment_type === null ? false : ['paid', 'refunded'].includes(val.saved_status)}
                              // disabled={(val.payment_type === 'card' && ['paid'].includes(val.saved_status)) || !['unpaid', 'failed'].includes(val.status)}
                              />
                            </div>
                            {['paid', 'refunded'].includes(val.saved_status) && <div className="in-card-item">
                              <span>Payment Type</span>
                              <input type="text" placeholder="" name="payment_type" value={val.payment_type === 'card' ? 'Card' : 'Cash'} disabled />
                            </div>}
                            <div className="in-card-item in-card-action">
                              <div className="ac-btns-side">
                                {
                                  val.id && val.status !== 'refunded' &&
                                  <button className="btn with-icon pri" onClick={() => sendEmail(k)}>
                                    <img src={sendIcon} alt="" /> {val.sent_to_user ? 'Resend' : 'Send'}
                                  </button>
                                }

                                {
                                  val.id && val.status === 'refunded' && 
                                  <button className="btn btn-sec with-icon not-allowed" disabled onClick={() => {}} >
                                    <img src={refundIcn} alt="" /> Refunded
                                  </button>
                                }

                                <button className="btn btn-sec with-icon" onClick={() => removeInvoice(k)} >
                                  <img src={trashIcon} alt="" /> Remove
                                </button>
                                {
                                  val.id && val.status === 'paid' && val.payment_type === 'card' &&
                                  <button className="btn btn-sec with-icon refund" onClick={() => refundAmount(val)} >
                                    <img src={refundIcn} alt="" /> Refund
                                  </button>
                                }
                              </div>
                              {/* <div className="ac-more-btn" classas={k}>
                            {
                              invoiceList.length > 1 &&
                              <span className="active">
                                <img src={minusIcon} alt="" onClick={() => removeInvoice(k)} />
                              </span>
                            }
                          </div> */}
                            </div>
                          </div>

                          <div className="invoice-sent-time">
                            <span>
                              {
                                val.sent_to_user && <div className="invoice-sent-time"> <span><strong>Invoice Sent: </strong> {moment(val.sent_date).format('MM/DD/YYYY hh:ss A')}</span> </div>
                              }
                            </span>
                            <span>
                              {
                                val.paid_date && <div className="invoice-sent-time"> <span><strong>Paid On: </strong> {moment(val.paid_date).format('MM/DD/YYYY hh:ss A')}</span> </div>
                              }
                            </span>
                          </div>
                        </div>
                        <div className="in-card-body">
                          <table>
                            <thead>
                              <tr>
                                <th className="th tb-cell th-item left-align">
                                  Item
                                </th>
                                <th className="th tb-cell th-qty">Qty/Hrs</th>
                                <th className="th tb-cell th-cost">Unit Cost</th>
                                <th className="th tb-cell th-tax">Tax</th>
                                <th className="th tb-cell th-total">Total</th>
                                <th className="th tb-cell th-add-btn"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                val.event_invoice_details && val.event_invoice_details.length && val.event_invoice_details.map((item, j) => (
                                  <tr key={j}>
                                    <td className="td tb-cell left-align">
                                      <textarea
                                        name="item"
                                        placeholder="Item Details"
                                        value={item.item}
                                        onChange={(e) => formChangeSub(e, k, j)}
                                        className={`${errors[k] && val.submitted && errors[k]?.event_invoice_details[j] && errors[k]?.event_invoice_details[j].item ? 'errors' : ''}`}
                                        disabled={!['unpaid'].includes(val.saved_status)}
                                      ></textarea>
                                    </td>
                                    <td className="td tb-cell">
                                      <NumberFormat value={item.qty} displayType={'input'} thousandSeparator={true} name="qty"
                                        onValueChange={(e) => e && formChangeSub({ target: { name: 'qty', value: e.value } }, k, j)}
                                        className={`${errors[k] && val.submitted && errors[k]?.event_invoice_details[j] && errors[k]?.event_invoice_details[j].qty ? 'errors' : ''}`}
                                        disabled={!['unpaid'].includes(val.saved_status)}
                                      />
                                    </td>
                                    <td className="td tb-cell">
                                      <NumberFormat value={item.unit_cost} displayType={'input'} thousandSeparator={true} prefix={'$'} name="unit_cost"
                                        onValueChange={(e) => e && formChangeSub({ target: { name: 'unit_cost', value: e.value } }, k, j)}
                                        className={`${errors[k] && val.submitted && errors[k]?.event_invoice_details[j] && errors[k]?.event_invoice_details[j].unit_cost ? 'errors' : ''}`}
                                        disabled={!['unpaid'].includes(val.saved_status)}
                                      />
                                    </td>
                                    <td className="td tb-cell">
                                      <NumberFormat value={item.tax} displayType={'input'} thousandSeparator={true} prefix={'$'} name="tax"
                                        onValueChange={(e) => e && formChangeSub({ target: { name: 'tax', value: e.value } }, k, j)}
                                        className={`${errors[k] && val.submitted && errors[k]?.event_invoice_details[j] && errors[k]?.event_invoice_details[j].tax ? 'errors' : ''}`}
                                        disabled={!['unpaid'].includes(val.saved_status)}
                                      />
                                    </td>
                                    <td className="td tb-cell">
                                      <NumberFormat value={item.total} displayType={'input'} thousandSeparator={true} prefix={'$'} name="total" disabled
                                        onValueChange={(e) => e && formChangeSub({ target: { name: 'total', value: e.value } }, k, j)}
                                        className={`${errors[k] && val.submitted && errors[k]?.event_invoice_details[j] && errors[k]?.event_invoice_details[j].total ? 'errors' : ''}`}
                                      />
                                    </td>
                                    <td className="td tb-cell tb-add-btn">
                                      <div className="cell-add-btn ">
                                        {
                                          j === val.event_invoice_details.length - 1 &&
                                          <div className={!['unpaid'].includes(val.saved_status) ? 'disabled-input' : ''}>
                                            <img src={plusIcon} alt="" onClick={() => addInvoiceItem(k)} />
                                          </div>
                                        }

                                        {
                                          val.event_invoice_details.length > 1 &&
                                          <div className={!['unpaid'].includes(val.saved_status) ? 'disabled-input' : ''}>
                                            <img src={minusPriIcon} alt="" onClick={() => removeInvoiceItem(k, j)} />
                                          </div>
                                        }
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              }
                              <tr>
                                <td colSpan={'3'}>
                                  <button className={`btn ${val.payment_type === null ? '' : ['paid', 'refunded'].includes(val.saved_status) ? 'disabled-input' : ''}`} onClick={() => submitInvoice(k)} disabled={val.payment_type === null ? false : ['paid', 'refunded'].includes(val.saved_status)}>Save</button>
                                </td>
                                <td className="td tb-cell tb-total" colSpan={'100'}>
                                  <span>Stripe Fee: <b><NumberFormat value={val.stripe_fee} displayType={'text'} thousandSeparator={true} prefix={'$'} /></b></span>
                                  <span>Total Invoice: <b><NumberFormat value={val.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></b></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {
        refundPopup && <RedundPopup total={refundInfo.total} close={() => setRefundPopup(false)} refund={(e) => refund(e)} max={refundInfo.total}></RedundPopup>
      }
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => setOpenWarningPopup(false)}
      />
    </>
  );
}

export default withRouter(Invoices);
